import { CheckboxInput } from "@fidget/common/components/form/checkboxInput";
import { EditTextarea } from "@fidget/common/components/form/editTextarea";
import { intl } from "@fidget/common/i18n";
import { observer } from "mobx-react";
import React from "react";
import settingsStyles from "../../../../styles/settings.css";
import { InputsRow } from "../InputsRow/InputsRow";
import { WithLocaleHeader } from "../WithLocaleHeader/WithLocaleHeader";
import { MainNotificationForm } from "./types";
import styles from "./mainNotificationInput.css";
import { staticConfig } from "@fidget/common/config";

interface Props {
  fields: MainNotificationForm[];
}
export const MainNotificationInput = observer(function MainNotificationInputComponent({
  fields
}: Props) {
  return (
    <>
      <CheckboxInput
        value={fields[0]?.$.enabled.$ || false}
        id="main_notifications_enabled"
        label={intl.formatMessage("settings.mainNotifications.checkbox")}
        onChange={(enabled) => fields.forEach((f) => f.$.enabled.reset(enabled))}
        className={styles.checkbox}
      />
      <InputsRow>
        {fields.map((field) => (
          <WithLocaleHeader key={field.$.locale.$} locale={field.$.locale.$}>
            <EditTextarea
              className={settingsStyles["input-width-bigger"]}
              value={field.$.text.$}
              placeholder={intl.formatMessage("settings.mainNotifications.text.placeholder")}
              onChange={(e) => field.$.text.reset((e.target as HTMLTextAreaElement).value)}
              maxLength={staticConfig.mainNotificationMaxCharacters}
            />
          </WithLocaleHeader>
        ))}
      </InputsRow>
    </>
  );
});
